function scrollTop(scrollDuration) {
  const scrollStep = -window.pageYOffset / (scrollDuration / 15);
  const scrollInterval = setInterval(() => {
    if (window.pageYOffset !== 0) {
      window.scrollBy(0, scrollStep);
    } else clearInterval(scrollInterval);
  }, 15);
}

export default scrollTop;
